import { Component, OnInit } from '@angular/core';
import { IndexedDBService } from "@core/services/indexeddb.service";
import { CryptoService } from "@core/services/crypto.service";
import { IRevisione } from "../../../revisione53/core/models/interfaces/revisione.interface";
import { IDatiBusiness } from "../../../revisione53/core/models/interfaces/dati-business.interface";
import { IRevisioneDatiBusiness } from "../../../revisione53/core/models/interfaces/revisione-business.interface";
import { revisione53CoreHelpers } from "../../../revisione53/core/components/main-container/revisione53-main-container.helpers";
import { JSON_FILE_PREFIX } from "@shared/constants/shared.constants";
import { nanoid } from "nanoid";
import { mergeMap } from "rxjs/operators";
import { cloneDeep, set } from 'lodash-es'
import { Store } from '@ngrx/store';
import { Revisione53CoreActions } from 'app/features/revisione53/core/store/revisione53.actions';
import { Revisione53State } from 'app/features/revisione53/core/store/revisione53.reducers';
import { ToastrService } from "ngx-toastr";

@Component({
    selector: 'app-offline-upload',
    templateUrl: './offline-upload.component.html',
    styleUrls: ['./offline-upload.component.scss']
})
export class OfflineUploadComponent implements OnInit {

    revisioniInLocalStorage: { idAssegnazione: string; denomEnte: string; revisore: string; codiceFiscale: string; anno1: string; anno2: string }[] = [];
    localStorageSize: string;

    constructor(
        private indexedDb: IndexedDBService,
        private cryptoService: CryptoService,
        private store: Store<Revisione53State>,
        private toastr: ToastrService,
    ) {
    }

    ngOnInit(): void {

        try {
            this.revisioniInLocalStorage = Object.keys(localStorage)
                .filter((key) => key.startsWith('confcooperative-revisione') && !key.includes('null'))
                .map((key) => {

                    const regex = /^confcooperative-revisione(\d+)-(\d+)$/gm;
                    let { 1: nRevisione, 2: idAssegnazione } = regex.exec(key);

                    let denomEnte: string, revisore: string, codiceFiscale: string, anno1: string, anno2: string;
                    const storageValue = localStorage.getItem(key);
                    if (storageValue) {
                        const json = JSON.parse(storageValue);
                        denomEnte = json.revisione.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DenominazEntePrecaricata;
                        revisore = json.revisione.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_Revisore;
                        codiceFiscale = json.revisione.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CodFisc;
                        anno1 = json.revisione.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_Anno1;
                        anno2 = json.revisione.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_Anno2;

                        if (!idAssegnazione) idAssegnazione = json.revisione.idassegnazione;
                    }

                    return { nRevisione, idAssegnazione, denomEnte, revisore, codiceFiscale, anno1, anno2 };
                });

            let _lsTotal = 0, _xLen, _x;
            for (_x in localStorage) {
                if (!localStorage.hasOwnProperty(_x)) { continue; }
                _xLen = ((localStorage[_x].length + _x.length) * 2);
                _lsTotal += _xLen;
            }

            console.log("Total = " + (_lsTotal / 1024).toFixed(2) + " KB");
            this.localStorageSize = (_lsTotal / 1024).toFixed(2) + " KB";
        } catch (err) {
            console.error('error parsing revisioni from localStorage: ', err);
        }
    }

    upload(event): void {
        const inputFile = event.currentTarget;
        const selectedFile = inputFile.files[0];
        console.log('upload -> event: ', event);

        if (selectedFile) {
            const fileReader = new FileReader();
            fileReader.readAsText(selectedFile);
            fileReader.onload = () => {
                try {
                    const decryptPsw = prompt("Inserisci la password con cui è stato salvato il file");

                    const fileReaderResult = this.cryptoService.decrypt(fileReader.result as string, decryptPsw);
                    const jsonInput: { revisione: IRevisione, datiBusiness: IDatiBusiness } = JSON.parse(fileReaderResult);

                    if (!jsonInput.revisione || !jsonInput.datiBusiness) {
                        alert('Il file inserito non è valido')
                        this.toastr.error('Il file caricato non è stato riconosciuto come un backup.', 'Attenzione',
                            { tapToDismiss: true, closeButton: true, timeOut: 0, disableTimeOut: true });
                        throw new Error('json inserito non valido - proprietà revisione e/o datiBusiness non leggibili');
                    }

                    this.uploadRevisione(jsonInput);

                } catch (err) {
                    debugger;
                    console.error("parsing file fallito", err);

                    this.toastr.error('Errore nel caricamento del backup del verbale di revisione. Controlla che la password sia corretta.', 'Attenzione',
                        { tapToDismiss: true, closeButton: true, timeOut: 0, disableTimeOut: true });

                    inputFile.reset();
                }
            }
            fileReader.onerror = (error) => {
                console.error('fileReader.onerror', error);
                inputFile.reset();
            }
        }
    }

    private uploadRevisione(uploadedRevisioneDatiBusiness: IRevisioneDatiBusiness): void {
        let positions = revisione53CoreHelpers.getAllegatiPositionAndValue(uploadedRevisioneDatiBusiness.revisione, JSON_FILE_PREFIX);
        let revisione: IRevisione = cloneDeep(uploadedRevisioneDatiBusiness.revisione)

        const filesToAdd = positions.map(p => {

            const file = revisione53CoreHelpers.fromBase64StringToFile(p.value)

            return {
                ...p,
                file,
                id: nanoid()
            }
        })

        if (!navigator.onLine && this.revisioniInLocalStorage.length === 0) {
            localStorage.clear();
        }

        // SE LA REVISIONE È PRESENTE NEL LOCALSTORAGE VA SOSTITUITA, SENNÒ VA SEMPLICEMENTE INSERITA.
        if (this.isRevisioneInLocalStorage(revisione)) {
            // TODO: togli tutti gli allegati della revisione49 attualmente presente

            this.indexedDb.bulkAdd(filesToAdd).pipe(
                mergeMap(() => {
                    filesToAdd.forEach(file => {
                        set(revisione, file.position, IndexedDBService.idPrefix + file.id)
                    })

                    const ids: string[] = revisione53CoreHelpers.getAllegatiPositionAndValue(revisione).map(a => a.value);

                    return this.indexedDb.bulkDelete(ids);
                })
            ).subscribe(() => {
                // TODO: anzichè fare la store.dispatch fare il replace sul localStorage, tanto la chiave è la stessa visto che la revisione
                setTimeout(() => {
                    this.store.dispatch(Revisione53CoreActions.revisione53hydrated({
                        revisione,
                        datiBusiness: uploadedRevisioneDatiBusiness.datiBusiness
                    }))
                    window.location.reload();
                }, 2000)
            })
        } else {

            const LOCALSTORAGE_KEY = `confcooperative-revisione53-${ revisione.idassegnazione }`;

            if (!revisione || !revisione.idassegnazione) {
                console.trace('LOCALSTORAGE_KEY problem: ', LOCALSTORAGE_KEY);
            }

            localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(uploadedRevisioneDatiBusiness));

            setTimeout(() => {
                window.location.reload();
            }, 2000)
        }

    }

    private isRevisioneInLocalStorage(revisione: IRevisione): boolean {
        return this.revisioniInLocalStorage.map(e => e.idAssegnazione).includes(revisione.idassegnazione);
    }


    // private deleteAllegati(revisione?: IRevisione) {
    // return this.store.select(Revisione49CoreSelectors.getRevisione).pipe(
    //   take(1),
    //   map(() => Revisione49CoreHelpers.getAllegatiPositionAndValue(revisione).map(a => a.value)),
    //   mergeMap(ids => this.indexedDb.bulkDelete(ids))
    // )
    // }

}
